function DualPath(params) {
    if(!params || !$(params.container).length) {
        return;
    }
    
    this.setDefaults(params);
    this.addListeners();
    this.enableTabs();
}

DualPath.prototype.setDefaults = function(params) {
    this.activeClass = params.activeClass;
    this.dotWrapper = params.dotWrapper;
    this.scrollSpeed = params.scrollSpeed || slow;
    this.xTimer = null;
    this.xScrollTimeout = params.xScrollTimeout;
    
    if(params.dotAnchor) {
        var dotContainer = $(params.dotAnchor).first(), 
        dots = "<div class=" + this.dotWrapper.slice(1) + "><button class='nav-dot active'></button><button class='nav-dot'></button></div>";
        
        dotContainer.prepend(dots);
        dotContainer.append(dots);
    }
    
    this.dom = {
        $container: $(params.container),
        $tabs: $(params.tabWrapper),
        $tab: $(params.tabItem),
        $columns: $(params.container).children(),
        $left: $(params.leftIndicators),
        $right: $(params.rightIndicators),
        $dots: (params.dotAnchor ? $(params.container).find(this.dotWrapper) : null),
        $tiles: (params.tileClass ? $(params.container).find(params.tileClass) : null)
    };

    this.stickyStart = this.dom.$container.offset().top - this.dom.$tabs.height();
    this.stickyEnd = this.dom.$container.offset().top + this.dom.$container.height() - this.dom.$tabs.height();
}

DualPath.prototype.addListeners = function() {
    $(window).on('resize', this.enableTabs.bind(this));
    this.dom.$container.on('scroll', this.updateScrolls.bind(this));
    this.dom.$container.on('touchstart touchend', this.handleTouchEvents.bind(this));
    this.dom.$left.on('click touchstart keyup', this.scroll.bind(this, false));
    this.dom.$right.on('click touchstart keyup', this.scroll.bind(this, true));

    var instance = this;
    $(window).on('scroll', this.repositionTabs.bind(this));
    $(window).on('resize', function() {
        instance.balanceTiles();
        instance.equalizeHeights();
        instance.repositionTabs();
    }).resize();
}


DualPath.prototype.enableTabs = function() {
    const mq = window.matchMedia( "(max-width: 1280px)" );

    if (mq.matches) {
        this.dom.$tab.attr('tabindex', '0');
    } else {
        this.dom.$tab.attr('tabindex', '-1');
    }
}

DualPath.prototype.handleTouchEvents = function(e) {
    if (e.type === "touchstart") {
        this.touchStart = e.originalEvent.changedTouches[0];
        this.scrollTopStart = $(document).scrollTop();
        return;
    }
    
    var touchEnd = e.originalEvent.changedTouches[0];
    this.scrollTopEnd = $(document).scrollTop();

    var tolerance = 0.2,
        scrollTolerance = 1, 
        vector = {
            i: (this.touchStart.pageX - touchEnd.pageX) / this.touchStart.pageX, 
            j: (this.touchStart.pageY - touchEnd.pageY) / this.touchStart.pageY
        },
        scroll = Math.abs(this.scrollTopStart - this.scrollTopEnd);

    if(Math.abs(vector.i) > tolerance && scroll < scrollTolerance) {
        this.scroll(vector.i > 0);
    }
};

DualPath.prototype.repositionTabs = function() {
    var pageOffset = window.pageYOffset, leftOffset = ($(window).width() - this.dom.$tabs.width()) / 2;
    var pos = (pageOffset >= this.stickyStart && pageOffset < this.stickyEnd) ? 'fixed' : 'relative';
    
    if(pos === 'fixed') {
        this.dom.$tabs.css({
            position: pos,
            top: 0,
            left: leftOffset
        });
        this.dom.$container.css('padding-top', this.dom.$tabs.height());
    } else {
        this.dom.$tabs.attr('style', '');
        this.dom.$container.attr('style', '');
    }
}

DualPath.prototype.scroll = function(direction, event) {
    if (event.type = 'keyup' && (event.keyCode !== 13 && event.keyCode !== 32)) return;
    event.preventDefault();

    var width = this.dom.$container.width() * (direction ? 1 : -1);
    
    this.dom.$container.animate({
        scrollLeft: width
    }, this.scrollSpeed);
    
    this.updateScrolls();
}

DualPath.prototype.updateScrolls = function() {
    clearTimeout(this.timer);
    
    var instance = this;
    this.xTimer = setTimeout(function() {
        var source, target, totalWidth = 0, left;
        
        instance.dom.$container.children().each(function(i, el) {
            totalWidth += $(el).width();
        });
        
        if(instance.dom.$container.scrollLeft() > 0) {
            source = instance.dom.$left;
            target = instance.dom.$right;
            left = totalWidth - instance.dom.$container.width();
        } else {
            source = instance.dom.$right;
            target = instance.dom.$left;
            left = 0;
        }
        
        source.removeClass(instance.activeClass);
        target.addClass(instance.activeClass);
        
        instance.dom.$container.find(instance.dotWrapper).css({
            'left': left
        });
    }, this.xScrollTimeout);
}

DualPath.prototype.equalizeHeights = function() {
    var elements = this.dom.$columns.children();
    var heights = [];
    
    elements.each(function() {
        var el = $(this);
        el.css('min-height', 'auto');
        if(!heights[el.index()] || el.outerHeight() > heights[el.index()]) {
            heights[el.index()] = el.outerHeight();
        }
    }).each(function() {
        var el = $(this);
        if(el.height() < heights[el.index()]) {
            el.css('min-height', heights[el.index()]);
        }
    });

    this.stickyStart = this.dom.$container.offset().top - this.dom.$tabs.height();
    this.stickyEnd = this.dom.$container.offset().top + this.dom.$container.height() - this.dom.$tabs.height();
}

DualPath.prototype.balanceTiles = function() {
    var tiles = this.dom.$tiles;
    var heights = [];
    
    tiles.css('height', 'auto').each(function() {
        var item = $(this);
        if(!heights[item.index()] || heights[item.index()] < item.height())
            heights[item.index()] = item.height();
    }).each(function() {
        var item = $(this);
        item.height(heights[item.index()]);
    });
}

var pathController = new DualPath({
    container: '.partner-landing-columns__wrapper',
    tabWrapper: '.partner-landing__choose-your-path-tabs-wrapper',
    tabItem: '.partner-landing__choose-your-path-tab',
    leftIndicators: '.partner-landing__choose-your-path-tab:first-child, .nav-dot:first-child',
    rightIndicators: '.partner-landing__choose-your-path-tab:last-child, .nav-dot:last-child',
    dotWrapper: '.nav-dots',
    dotAnchor: '.available-programs__section',
    activeClass: 'active',
    scrollDirection: true,
    scrollSpeed: 'slow',
    xScrollTimeout: 100,
    yScrollTimeout: 50,
    tileClass: '.partner-landing-description__tile'
});